module.exports = __webpack_public_path__ + "static/img/yagi_07.6f5fee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yagi_07.jpg
// module id = es9H
// module chunks = 0